import CalendarOutlined from '@ant-design/icons/CalendarOutlined'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import InfoCircleTwoTone from '@ant-design/icons/InfoCircleTwoTone'
import { Button, Dropdown, Menu, message, Modal, Steps, Upload, Tabs } from 'antd'
import groupBy from 'lodash/groupBy'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { blue } from '../../../../color'
import AccessControlAction from '../../../../components/AccessControlAction/AccessControlAction'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import {
  EmptyText,
  TitleContentBox,
} from '../../../../components/Common/CellText'
import FileItem from '../../../../components/Common/FileItemComponent/FileItem'
import LinkedWork from '../../../../components/Common/Linked/LinkedWork'
import ContentBlockWrapper from '../../../../components/ContentBlockWrapper'
import PDFViewer from '../../../../components/PDFViewer/PDFViewer'
import PopupRenameFile from '../../../../components/PopupRenameFile'
import PopupSign from '../../../../components/PopupSign'
import ModalPopupSign from '../../../../components/PopupSign/ModalPopupSign'
import PopupTPApproverSign from '../../../../components/PopupSign/PopupTPApproverSign'
import TPPopupSign from '../../../../components/PopupSign/TPPopupSign'
import VTPopupSign from '../../../../components/PopupSign/VTPopupSign'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SpinnerInlineComponent from '../../../../components/SpinnerInlineComponent/SpinnerInlineComponent'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_DEFAULT,
  ELECTRONIC_DOCUMENT_STATUS,
} from '../../../../constants'
import dayjs from '../../../../dayjsConfig'
import utils from '../../../../utils'
import { CustomStepIcon } from '../../InternalDocumentSignDocPage/PopupCreateSignDoc/PopupCreateSignDocStyled'
import CommentBlock from '../CommentBlock'
import InternalDocumentSignDocHistory from '../InternalDocumentSignDocHistory/InternalDocumentSignDocHistory'
import PopupReleaseElectronicDocument from '../PopupReleaseElectronicDocument'
import {
  BlockRight,
  ButtonItem,
  CanvasDocHeader,
  CanvasDocWrapper,
  ElectronicDocumentInfo,
  ViewerWrapper,
} from './CanvasDocStyled'
import PopupRegisNumber from './PopupRegisNumber'

const { confirm } = Modal
const { Step } = Steps

const CanvasDoc = props => {
  const {
    signedDocumentStore,
    loadingAnimationStore,
    fileStore,
    electronicDocumentStore,
    listHistoryLogStore,
    authenticationStore,
    selectPeopleStore,
    aclStore,
    getElectronicDocumentById,
  } = props
  const { selectedElectronicDocument } = electronicDocumentStore
  const { historyLists } = listHistoryLogStore
  const { checkAccessControlAction } = aclStore
  const { currentUser } = authenticationStore
  const {
    setSelectUserData,
    selectUserData,
    setSelectDepartmentData,
    selectDepartmentData,
    originDepartmentWithUserList,
    handleCancelSelectUserDepartment,
    setIsVisibleSelectUserDepartmentPopup,
    isVisibleSelectUserDepartmentPopup,
  } = selectPeopleStore

  const {
    action_history,
    assignees,
    attachments,
    annex_attachments,
    code,
    status,
    created_date,
    linked_work,
    permission,
  } = selectedElectronicDocument || {}
  const linkedWorkList = linked_work && linked_work.code ? [linked_work] : []
  const { documentAttachment } = fileStore

  // Centralized popup visibility state
  const [popupVisibility, setPopupVisibility] = useState({
    regisNumber: false,
    sign: false,
    modalSign: false,
    tpSign: false,
    vtSign: false,
    release: false,
    tpCoSign: false,
  })

  const [currentStep, setCurrentStep] = useState(0)
  const [statusStep, setStatusStep] = useState(Array(7).fill('await'))
  const [fileActive, setFileActive] = useState(null)
  const [fileActiveIsPDF, setFileActiveIsPDF] = useState(false)
  const [handlerName, setHandlerName] = useState({
    creator_name: undefined,
    tp_approval_name: undefined,
    vt_approval_name: undefined,
    lead_approval_name: undefined,
    regis_number_name: undefined,
    sign_document_name: undefined,
    release_name: undefined,
  })
  const [skipSignStates, setSkipSignStates] = useState({
    sign: false,
    tp: false,
    lead: false,
    num: false,
  })
  const [renameFileState, setRenameFileState] = useState({
    visible: false,
    ext: '',
    fields: [{ name: ['rename'], value: '' }],
  })
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)

  const [currentCoSignerIndex, setCurrentCoSignerIndex] = useState(0)

  const checkPermission = useCallback(
    key => permission?.split(',').includes(key) || false,
    [permission]
  )

  const assigneesMap = useMemo(
    () => ({
      creator: assignees?.find(el => el.permission === ASSIGNEE_TYPE.CREATE),
      departmentApprover: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.DEPARTMENT_APPROVER
      ),
      formApprover: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.FORM_APPROVER
      ),
      leaderApprover: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.LEADER_APPROVER
      ),
      numberIssuer: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.NUMBER_ISSUER
      ),
      digitalSigner: assignees?.find(
        el => el.permission === ASSIGNEE_TYPE.DIGITAL_SIGNER
      ),
      departmentCoSigners: assignees?.filter(
        el => el.permission === ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER
      ),
      releaser: assignees?.find(el => el.permission === ASSIGNEE_TYPE.RELEASER),
    }),
    [assignees, selectedElectronicDocument]
  )

  const coSigners = assigneesMap.departmentCoSigners || []

  const { [ASSIGNEE_TYPE.USER]: allUsers = [] } = useMemo(
    () => groupBy(assignees || [], 'assignee_type'),
    [assignees]
  )

  const userList = useMemo(
    () => allUsers.filter(el => el.permission !== ASSIGNEE_TYPE.CREATE),
    [allUsers]
  )

  useEffect(() => {
    if (!isVisibleSelectUserDepartmentPopup) return

    const currentCoSigners = assigneesMap.departmentCoSigners.map(coSigner => ({
      id: coSigner.assignee_code,
      full_name: coSigner.name_uppercase,
      image_id: coSigner.image,
      assignee_type: coSigner.assignee_type,
      permission: coSigner.permission,
    }))

    selectPeopleStore.setSelectUserData({
      ...selectPeopleStore.selectUserData,
      [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: currentCoSigners,
    })
  }, [
    isVisibleSelectUserDepartmentPopup,
    assigneesMap.departmentCoSigners,
    selectPeopleStore,
  ])

  useEffect(() => {
    if (props.onStepChange) {
      props.onStepChange(currentStep)
    }
  }, [currentStep, props.onStepChange])

  const getHistoryList = useCallback(async () => {
    if (code) {
      try {
        await listHistoryLogStore.getLists(code)
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    }
  }, [code, listHistoryLogStore])

  useEffect(() => {
    if (code) {
      getHistoryList()
    }
  }, [code, status, getHistoryList])

  useEffect(() => {
    if (fileActive?.file_id === null) {
      getElectronicDocumentById()
    }
  }, [fileActive?.file_id, getElectronicDocumentById])

  // General action handler
  const handleAction = useCallback(
    async (action, fileId, successMessage, permissionType, preCheck) => {
      if (permissionType && !checkPermission(permissionType)) {
        message.warning('Bạn không có quyền thực hiện hành động này!')
        return
      }

      if (preCheck && !preCheck()) return
      try {
        loadingAnimationStore.showSpinner(true)
        await electronicDocumentStore.updateElectronicDocumentStatus(
          { action, file_id: fileId },
          code
        )
        await electronicDocumentStore.getElectronicDocumentById(code)
        message.success(successMessage)

        // Update file attachment after signing
        if (fileId) {
          await fileStore.downloadAttachment(fileId)
        }
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [
      code,
      checkPermission,
      electronicDocumentStore,
      loadingAnimationStore,
      fileStore,
    ]
  )

  const checkStepPermission = useCallback(
    (step, permissionType, assignee, messageText) => {
      if (checkPermission(permissionType) && !assignee) {
        message.warning(messageText)
        return false
      }
      return true
    },
    [checkPermission]
  )

  const handlePresentDuThao = useCallback(() => {
    if (currentStep === 0) {
      const allSteps = [
        {
          permissionType: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
          assignee: assigneesMap.departmentApprover,
          message: 'Bạn chưa chọn trưởng phòng duyệt!',
        },
        {
          permissionType: ASSIGNEE_TYPE.FORM_APPROVER,
          assignee: assigneesMap.formApprover,
          message: 'Bạn chưa chọn người duyệt thể thức!',
        },
        {
          permissionType: ASSIGNEE_TYPE.LEADER_APPROVER,
          assignee: assigneesMap.leaderApprover,
          message: 'Bạn chưa chọn lãnh đạo duyệt!',
        },
        {
          permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
          assignee: assigneesMap.numberIssuer,
          message: 'Bạn chưa chọn người cấp số!',
        },
        {
          permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
          assignee: assigneesMap.digitalSigner,
          message: 'Bạn chưa chọn người ký số điện tử!',
        },
        {
          permissionType: ASSIGNEE_TYPE.RELEASER,
          assignee: assigneesMap.releaser,
          message: 'Bạn chưa chọn người phát hành!',
        },
      ]

      const firstActiveStepWithAssignee = allSteps.find(
        step => checkPermission(step.permissionType) && step.assignee
      )

      if (!firstActiveStepWithAssignee) {
        const firstActiveStep = allSteps.find(step =>
          checkPermission(step.permissionType)
        )

        if (firstActiveStep) {
          message.warning(firstActiveStep.message)
          return
        }
      }
    }

    handleAction(
      ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL,
      fileActive?.file_id,
      'Trình dự thảo thành công!',
      null
    )
  }, [
    assigneesMap,
    checkPermission,
    currentStep,
    fileActive?.file_id,
    handleAction,
  ])

  const handleVTApproval = useCallback(() => {
    const allSteps = [
      {
        permissionType: ASSIGNEE_TYPE.LEADER_APPROVER,
        assignee: assigneesMap.leaderApprover,
        message: 'Bạn chưa chọn lãnh đạo duyệt!',
      },
      {
        permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
        assignee: assigneesMap.numberIssuer,
        message: 'Bạn chưa chọn người cấp số!',
      },
      {
        permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assignee: assigneesMap.digitalSigner,
        message: 'Bạn chưa chọn người ký số điện tử!',
      },
      {
        permissionType: ASSIGNEE_TYPE.RELEASER,
        assignee: assigneesMap.releaser,
        message: 'Bạn chưa chọn người phát hành!',
      },
    ]

    const nextStep = allSteps.find(step => checkPermission(step.permissionType))

    if (nextStep && !nextStep.assignee) {
      message.warning(nextStep.message)
      return
    }

    handleAction(
      ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL,
      fileActive?.file_id,
      'Văn thư đã duyệt thành công!',
      ASSIGNEE_TYPE.FORM_APPROVER
    )
  }, [assigneesMap, checkPermission, fileActive, handleAction])

  // Hàm mở popup ký số
  const handleOpenPopupSign = useCallback(() => {
    if (
      !checkStepPermission(
        6,
        ASSIGNEE_TYPE.RELEASER,
        assigneesMap.releaser,
        'Bạn chưa chọn người phát hành!'
      )
    ) {
      return
    }
    if (!fileActiveIsPDF) {
      message.info('Bạn chỉ được phép ký số file PDF')
      return
    }

    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({ name: fileActive?.file_name })
    setPopupVisibility(prev => ({ ...prev, sign: true }))
  }, [
    assigneesMap,
    fileActiveIsPDF,
    documentAttachment,
    fileActive,
    signedDocumentStore,
    setPopupVisibility,
  ])

  // Hàm mở popup ký số văn thư
  const handleOpenModalPopupVTSign = useCallback(() => {
    const allSteps = [
      {
        permissionType: ASSIGNEE_TYPE.LEADER_APPROVER,
        assignee: assigneesMap.leaderApprover,
        message: 'Bạn chưa chọn lãnh đạo duyệt!',
      },
      {
        permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
        assignee: assigneesMap.numberIssuer,
        message: 'Bạn chưa chọn người cấp số!',
      },
      {
        permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assignee: assigneesMap.digitalSigner,
        message: 'Bạn chưa chọn người ký số điện tử!',
      },
      {
        permissionType: ASSIGNEE_TYPE.RELEASER,
        assignee: assigneesMap.releaser,
        message: 'Bạn chưa chọn người phát hành!',
      },
    ]

    const nextStep = allSteps.find(step => checkPermission(step.permissionType))

    if (nextStep && !nextStep.assignee) {
      message.warning(nextStep.message)
      return
    }

    if (!fileActiveIsPDF) {
      message.info('Bạn chỉ được phép ký số file PDF')
      return
    }

    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({ name: fileActive?.file_name })
    setPopupVisibility(prev => ({ ...prev, vtSign: true }))
  }, [
    assigneesMap,
    fileActiveIsPDF,
    documentAttachment,
    fileActive,
    signedDocumentStore,
    setPopupVisibility,
    checkPermission,
  ])

  // Hàm mở popup ký số lãnh đạo
  const handleOpenModalPopupSign = useCallback(() => {
    const allSteps = [
      {
        permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
        assignee: assigneesMap.numberIssuer,
        message: 'Bạn chưa chọn người cấp số!',
      },
      {
        permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assignee: assigneesMap.digitalSigner,
        message: 'Bạn chưa chọn người ký số điện tử!',
      },
      {
        permissionType: ASSIGNEE_TYPE.RELEASER,
        assignee: assigneesMap.releaser,
        message: 'Bạn chưa chọn người phát hành!',
      },
    ]

    const nextStep = allSteps.find(step => checkPermission(step.permissionType))

    if (nextStep && !nextStep.assignee) {
      message.warning(nextStep.message)
      return
    }

    if (!fileActiveIsPDF) {
      message.info('Bạn chỉ được phép ký số file PDF')
      return
    }

    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({ name: fileActive?.file_name })
    setPopupVisibility(prev => ({ ...prev, modalSign: true }))
  }, [
    assigneesMap,
    fileActiveIsPDF,
    documentAttachment,
    fileActive,
    signedDocumentStore,
    setPopupVisibility,
    checkPermission,
  ])

  // Hàm mở popup ký số trưởng phòng
  const handleOpenTPPopupSign = useCallback(() => {
    const allSteps = [
      {
        permissionType: ASSIGNEE_TYPE.FORM_APPROVER,
        assignee: assigneesMap.formApprover,
        message: 'Bạn chưa chọn người duyệt thể thức!',
      },
      {
        permissionType: ASSIGNEE_TYPE.LEADER_APPROVER,
        assignee: assigneesMap.leaderApprover,
        message: 'Bạn chưa chọn lãnh đạo duyệt!',
      },
      {
        permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
        assignee: assigneesMap.numberIssuer,
        message: 'Bạn chưa chọn người cấp số!',
      },
      {
        permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assignee: assigneesMap.digitalSigner,
        message: 'Bạn chưa chọn người ký số điện tử!',
      },
      {
        permissionType: ASSIGNEE_TYPE.RELEASER,
        assignee: assigneesMap.releaser,
        message: 'Bạn chưa chọn người phát hành!',
      },
    ]

    const nextStep = allSteps.find(step => checkPermission(step.permissionType))

    const notSignedTP = assigneesMap.departmentCoSigners
      ?.filter(item => item.note !== 'Manager Signed')
      .map(item => ` ${utils.getNameInCapitalize(item.name_uppercase)} chưa ký`)

    if (notSignedTP?.length) {
      notSignedTP.forEach(msg => message.warning(msg))
      return
    }

    if (nextStep && !nextStep.assignee) {
      message.warning(nextStep.message)
      return
    }

    if (!fileActiveIsPDF) {
      message.info('Bạn chỉ được phép ký số file PDF')
      return
    }

    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({ name: fileActive?.file_name })
    setPopupVisibility(prev => ({ ...prev, tpSign: true }))
  }, [
    assigneesMap,
    checkPermission,
    fileActiveIsPDF,
    documentAttachment,
    fileActive?.file_name,
    signedDocumentStore,
    setPopupVisibility,
  ])

  // Hàm mở popup ký số cho trưởng phòng ký
  const handleOpenTPCoPopupSign = useCallback(
    coSigner => {
      if (!fileActiveIsPDF) {
        message.info('Bạn chỉ được phép ký số file PDF')
        return
      }

      signedDocumentStore.setFileBlob(documentAttachment)
      signedDocumentStore.setOriginFileObj({ name: fileActive?.file_name })
      // signedDocumentStore.setCurrentSigner(coSigner.assignee_code)
      setPopupVisibility(prev => ({ ...prev, tpCoSign: true }))
    },
    [fileActiveIsPDF, documentAttachment, fileActive, signedDocumentStore]
  )

  // Sau khi trưởng phòng ký hoàn tất
  const handleAfterTPCoSign = useCallback(
    async fileSignId => {
      if (!code) return
      try {
        loadingAnimationStore.showSpinner(true)

        await electronicDocumentStore.updateElectronicDocumentStatus(
          {
            action: ELECTRONIC_DOCUMENT_STATUS.TP_CO_SIGN,
            file_id: fileSignId,
          },
          code
        )
        await electronicDocumentStore.updateManagerSignedNote(
          currentUser.username,
          code
        )
        await electronicDocumentStore.getElectronicDocumentById(code)
        message.success(`Trưởng phòng đã ký thành công!`)

        if (fileSignId) {
          await fileStore.downloadAttachment(fileSignId)
        }

        setPopupVisibility(prev => ({ ...prev, tpCoSign: false }))
      } catch (err) {
        console.error('Error after signing:', err)
        message.error(err?.vi || 'Đã có lỗi xảy ra khi cập nhật tài liệu!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [
      code,
      currentCoSignerIndex,
      coSigners,
      selectedElectronicDocument,
      electronicDocumentStore,
      loadingAnimationStore,
      fileStore,
      setIsVisiblePopupSign,
      handleAction,
      checkPermission,
    ]
  )

  // Hàm xử lý xóa trưởng phòng ký
  const handleRemoveCoSigner = useCallback(
    async coSigner => {
      if (
        !checkPermission(ASSIGNEE_TYPE.CREATE) &&
        !checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)
      ) {
        message.warning('Bạn không có quyền xóa trưởng phòng ký!')
        return
      }

      try {
        loadingAnimationStore.showSpinner(true)
        const dataSubmit = {
          new_items: [],
          remove_items: [
            {
              assignee_code: coSigner.assignee_code,
              assignee_type: coSigner.assignee_type,
              permission: ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER,
            },
          ],
        }
        await electronicDocumentStore.updateAssignPerson(code, dataSubmit)

        // Lấy dữ liệu mới nhất từ server
        const {
          data,
        } = await electronicDocumentStore.getElectronicDocumentById(code)

        // Cập nhật selectUserData trong selectPeopleStore
        const updatedCoSigners = data.assignees
          .filter(el => el.permission === ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER)
          .map(coSigner => ({
            id: coSigner.assignee_code,
            full_name: coSigner.name_uppercase,
            image_id: coSigner.image,
            assignee_type: coSigner.assignee_type,
            permission: coSigner.permission,
          }))

        selectPeopleStore.setSelectUserData({
          ...selectPeopleStore.selectUserData,
          [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: updatedCoSigners,
        })

        message.success('Xóa trưởng phòng ký thành công!')
      } catch (err) {
        console.error(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [
      code,
      electronicDocumentStore,
      loadingAnimationStore,
      checkPermission,
      selectPeopleStore,
    ]
  )

  // Hàm xử lý bỏ qua ký số
  const handleDismissSign = useCallback(() => {
    if (
      !checkStepPermission(
        6,
        ASSIGNEE_TYPE.RELEASER,
        assigneesMap.releaser,
        'Bạn chưa chọn người phát hành!'
      )
    ) {
      return
    }

    handleAction(
      ELECTRONIC_DOCUMENT_STATUS.READY,
      fileActive?.file_id,
      'Bạn đã bỏ qua bước ký số!',
      ASSIGNEE_TYPE.DIGITAL_SIGNER
    )
  }, [assigneesMap, fileActive, handleAction])

  // Hàm xử lý bỏ qua ký số trưởng phòng
  const handleDismissTPSign = useCallback(() => {
    const allSteps = [
      {
        permissionType: ASSIGNEE_TYPE.FORM_APPROVER,
        assignee: assigneesMap.formApprover,
        message: 'Bạn chưa chọn người duyệt thể thức!',
      },
      {
        permissionType: ASSIGNEE_TYPE.LEADER_APPROVER,
        assignee: assigneesMap.leaderApprover,
        message: 'Bạn chưa chọn lãnh đạo duyệt!',
      },
      {
        permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
        assignee: assigneesMap.numberIssuer,
        message: 'Bạn chưa chọn người cấp số!',
      },
      {
        permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assignee: assigneesMap.digitalSigner,
        message: 'Bạn chưa chọn người ký số điện tử!',
      },
      {
        permissionType: ASSIGNEE_TYPE.RELEASER,
        assignee: assigneesMap.releaser,
        message: 'Bạn chưa chọn người phát hành!',
      },
    ]

    const nextStep = allSteps.find(step => checkPermission(step.permissionType))

    if (nextStep && !nextStep.assignee) {
      message.warning(nextStep.message)
      return
    }

    handleAction(
      ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL,
      fileActive?.file_id,
      'Đã bỏ qua bước ký số!',
      ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
      () => {
        setSkipSignStates(prev => ({ ...prev, tp: true }))
        return true
      }
    )
  }, [
    assigneesMap,
    fileActive,
    handleAction,
    checkPermission,
    setSkipSignStates,
  ])

  // Hàm xử lý bỏ qua ký số lãnh đạo
  const handleDismissLeadSign = useCallback(() => {
    const allSteps = [
      {
        permissionType: ASSIGNEE_TYPE.NUMBER_ISSUER,
        assignee: assigneesMap.numberIssuer,
        message: 'Bạn chưa chọn người cấp số!',
      },
      {
        permissionType: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assignee: assigneesMap.digitalSigner,
        message: 'Bạn chưa chọn người ký số điện tử!',
      },
      {
        permissionType: ASSIGNEE_TYPE.RELEASER,
        assignee: assigneesMap.releaser,
        message: 'Bạn chưa chọn người phát hành!',
      },
    ]

    const nextStep = allSteps.find(step => checkPermission(step.permissionType))

    if (nextStep && !nextStep.assignee) {
      message.warning(nextStep.message)
      return
    }

    handleAction(
      ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL,
      fileActive?.file_id,
      'Đã bỏ qua bước ký số!',
      ASSIGNEE_TYPE.LEADER_APPROVER,
      () => {
        setSkipSignStates(prev => ({ ...prev, lead: true }))
        return true
      }
    )
  }, [
    assigneesMap,
    fileActive,
    handleAction,
    checkPermission,
    setSkipSignStates,
  ])

  // Hàm xử lý bỏ qua cấp số
  const handleDismissRegisNumber = useCallback(() => {
    if (
      !checkStepPermission(
        5,
        ASSIGNEE_TYPE.DIGITAL_SIGNER,
        assigneesMap.digitalSigner,
        'Bạn chưa chọn người ký số điện tử!'
      )
    ) {
      return
    }
    handleAction(
      ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER,
      fileActive?.file_id,
      'Bạn đã bỏ qua bước cấp số!',
      ASSIGNEE_TYPE.NUMBER_ISSUER,
      () => {
        setSkipSignStates(prev => ({ ...prev, num: true }))
        return true
      }
    )
  }, [assigneesMap, fileActive, handleAction, checkStepPermission])

  const handleRevertLeaderApproval = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      let fileIdToUpdate = action_history?.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL
      )?.file_id
      if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)) {
        fileIdToUpdate = action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL
        )?.file_id
      }
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.LEAD_REJECTION,
          file_id: fileIdToUpdate,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )
      message.info('Lãnh đạo đã hủy duyệt trình ký!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    action_history,
    code,
    checkPermission,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const handleRevertVTApproval = useCallback(async () => {
    if (!code) return
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.VT_REJECTION,
          file_id: action_history?.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL
          )?.file_id,
        },
        code
      )
      if (assigneesMap.departmentCoSigners.length > 0) {
        await electronicDocumentStore.deleteNote(
          code,
          ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER
        )
      }
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )
      message.info('Văn thư đã hủy duyệt')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    action_history,
    code,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const handleRevertRegisNumber = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      let fileIdToUpdate = action_history?.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL
      )?.file_id
      if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER)) {
        fileIdToUpdate = action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL
        )?.file_id
      } else if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) {
        fileIdToUpdate =
          action_history?.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL
          )?.file_id ||
          action_history?.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_SIGNED
          )?.file_id
      } else if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)) {
        fileIdToUpdate = action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL
        )?.file_id
      }
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER_REJECTION,
          file_id: fileIdToUpdate,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )
      message.info('Hãy cấp lại số tài liệu')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    action_history,
    code,
    checkPermission,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const handleRevertSign = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      let fileIdToUpdate = action_history?.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL
      )?.file_id
      if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) {
        fileIdToUpdate = action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
        )?.file_id
      } else if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER)) {
        fileIdToUpdate = action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL
        )?.file_id
      } else if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) {
        fileIdToUpdate =
          action_history?.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL
          )?.file_id ||
          action_history?.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_SIGNED
          )?.file_id
      } else if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)) {
        fileIdToUpdate = action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL
        )?.file_id
      }
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.READY_REJECTION,
          file_id: fileIdToUpdate,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )
      message.info('Bạn đã quay trở về bước ký số')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    action_history,
    code,
    checkPermission,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const handleRevertRelease = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.RELEASE_REJECTION,
          file_id: action_history?.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.RELEASE
          )?.file_id,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )
      message.info('Hãy phát hành lại tài liệu.')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    action_history,
    code,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const onSelectDocument = useCallback(
    async file => {
      const formData = new FormData()
      formData.append('file', file.file)
      loadingAnimationStore.showSpinner(true)
      try {
        const res = await fileStore.uploadFile(formData)
        await electronicDocumentStore.updateElectronicDocumentStatus(
          {
            action: ELECTRONIC_DOCUMENT_STATUS.CHANGE_DOC,
            file_id: res.data.file_id,
          },
          code
        )
        const response = await electronicDocumentStore.getElectronicDocumentById(
          code
        )
        await fileStore.downloadAttachment(
          response.data.action_history.find(
            el => el.action === response.data.status
          )?.file_id
        )
        await getHistoryList()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [
      code,
      electronicDocumentStore,
      fileStore,
      getHistoryList,
      loadingAnimationStore,
    ]
  )

  const submitRenameFile = useCallback(
    async value => {
      loadingAnimationStore.showSpinner(true)
      try {
        await fileStore.handleRenameFile(
          fileActive?.file_id,
          value.rename + renameFileState.ext
        )
        await electronicDocumentStore.getElectronicDocumentById(code)
        setRenameFileState(prev => ({ ...prev, visible: false }))
        message.success('Đổi tên tài liệu thành công!')
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [
      code,
      electronicDocumentStore,
      fileActive,
      fileStore,
      loadingAnimationStore,
      renameFileState,
      setRenameFileState,
    ]
  )

  const handleOpenPopupRenameFile = useCallback(() => {
    const ext = '.' + utils.getExtensionFile(fileActive?.file_name)
    setRenameFileState({
      visible: true,
      ext,
      fields: [
        {
          name: ['rename'],
          value: utils.removeExtensionFile(fileActive?.file_name),
        },
      ],
    })
  }, [fileActive, setRenameFileState])

  const handleAfterSign = useCallback(
    async fileSignId => {
      setPopupVisibility(prev => ({ ...prev, sign: false }))
      await electronicDocumentStore.updateElectronicDocumentStatus(
        { action: ELECTRONIC_DOCUMENT_STATUS.READY, file_id: fileSignId },
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      await fileStore.downloadAttachment(fileSignId)
    },
    [code, electronicDocumentStore, fileStore, setPopupVisibility]
  )

  const handleAfterVTSign = useCallback(
    async fileSignId => {
      setPopupVisibility(prev => ({ ...prev, vtSign: false }))
      await electronicDocumentStore.updateElectronicDocumentStatus(
        { action: ELECTRONIC_DOCUMENT_STATUS.VT_SIGNED, file_id: fileSignId },
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      await fileStore.downloadAttachment(fileSignId)
    },
    [code, electronicDocumentStore, fileStore, setPopupVisibility]
  )

  const handleAfterLeaderSign = useCallback(
    async fileSignId => {
      setPopupVisibility(prev => ({ ...prev, modalSign: false }))
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL,
          file_id: fileSignId,
        },
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      await fileStore.downloadAttachment(fileSignId)
    },
    [code, electronicDocumentStore, fileStore, setPopupVisibility]
  )

  const handleAfterTPSign = useCallback(
    async fileSignId => {
      setPopupVisibility(prev => ({ ...prev, tpSign: false }))
      await electronicDocumentStore.updateElectronicDocumentStatus(
        { action: ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL, file_id: fileSignId },
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      await fileStore.downloadAttachment(fileSignId)
    },
    [code, electronicDocumentStore, fileStore, setPopupVisibility]
  )

  const handleRevertTPApproval = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      const fileIdToUpdate =
        action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.CHANGE_DOC
        )?.file_id ||
        action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.PENDING
        )?.file_id

      if (!fileIdToUpdate) {
        throw new Error('Không tìm thấy tài liệu để quay lại!')
      }

      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.TP_REVERT,
          file_id: fileIdToUpdate,
        },
        code
      )

      if (assigneesMap.departmentCoSigners.length !== 0) {
        await electronicDocumentStore.deleteNote(
          code,
          ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER
        )
      }

      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )
      message.info('Đã quay lại bước Tạo dự thảo!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra khi quay lại bước Tạo dự thảo!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    code,
    action_history,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const handleRevertToLeaderApproval = useCallback(async () => {
    try {
      loadingAnimationStore.showSpinner(true)

      const leaderApprovalFileId =
        action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL
        )?.file_id ||
        action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL
        )?.file_id ||
        action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL
        )?.file_id ||
        action_history?.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL
        )?.file_id

      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER_REVERT,
          file_id: leaderApprovalFileId,
        },
        code
      )

      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )

      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status)?.file_id
      )

      const hasLeader = checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER)
      const hasForm = checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)
      const hasDepartment = checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)

      let revertedStep = 0
      let messageText = 'Đã quay lại bước Tạo dự thảo!'

      if (hasLeader) {
        revertedStep = 3
        messageText = 'Đã quay lại bước Lãnh đạo duyệt!'
      } else if (hasForm) {
        revertedStep = 2
        messageText = 'Đã quay lại bước Duyệt thể thức!'
      } else if (hasDepartment) {
        revertedStep = 1
        messageText = 'Đã quay lại bước Trưởng phòng duyệt!'
      }

      message.info(messageText)

      return {
        step: revertedStep,
        message: messageText,
      }
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    code,
    action_history,
    checkPermission,
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
  ])

  const showRevertTPConfirm = useCallback(
    () =>
      confirm({
        title: 'Bạn có muốn quay lại bước Tạo dự thảo?',
        icon: <InfoCircleTwoTone />,
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk: handleRevertTPApproval,
      }),
    [handleRevertTPApproval]
  )

  const showRevertToLeaderConfirm = useCallback(() => {
    const hasLeader = assignees?.some(a => a.permission === 'LEADER_APPROVER')

    if (hasLeader) {
      confirm({
        title: 'Bạn có muốn quay lại bước Lãnh đạo duyệt?',
        icon: <InfoCircleTwoTone />,
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk: handleRevertToLeaderApproval,
      })
    } else {
      handleRevertToLeaderApproval()
    }
  }, [assignees, handleRevertToLeaderApproval])

  // Step and status management
  useEffect(() => {
    if (!status) return
    switch (status) {
      case ELECTRONIC_DOCUMENT_STATUS.PENDING:
      case ELECTRONIC_DOCUMENT_STATUS.CHANGE_DOC:
      case ELECTRONIC_DOCUMENT_STATUS.TP_REVERT:
        setCurrentStep(0)
        break
      case ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL:
        if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER))
          setCurrentStep(1)
        else if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) setCurrentStep(2)
        else if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER))
          setCurrentStep(3)
        else if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) setCurrentStep(4)
        else if (checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER))
          setCurrentStep(5)
        else if (checkPermission(ASSIGNEE_TYPE.RELEASER)) setCurrentStep(6)
        else setCurrentStep(7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.VT_REJECTION:
        setCurrentStep(
          checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER) ? 1 : 0
        )
        break
      case ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL:
        if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) setCurrentStep(2)
        else if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER))
          setCurrentStep(3)
        else if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) setCurrentStep(4)
        else if (checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER))
          setCurrentStep(5)
        else if (checkPermission(ASSIGNEE_TYPE.RELEASER)) setCurrentStep(6)
        else setCurrentStep(7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.LEAD_REJECTION:
        if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) setCurrentStep(2)
        else if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER))
          setCurrentStep(1)
        else setCurrentStep(0)
        break
      case ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL:
      case ELECTRONIC_DOCUMENT_STATUS.VT_SIGNED:
        if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER)) setCurrentStep(3)
        else if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) setCurrentStep(4)
        else if (checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER))
          setCurrentStep(5)
        else if (checkPermission(ASSIGNEE_TYPE.RELEASER)) setCurrentStep(6)
        else setCurrentStep(7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL:
        if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) setCurrentStep(4)
        else if (checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER))
          setCurrentStep(5)
        else if (checkPermission(ASSIGNEE_TYPE.RELEASER)) setCurrentStep(6)
        else setCurrentStep(7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER_REJECTION:
        if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) setCurrentStep(4)
        else if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER))
          setCurrentStep(3)
        else if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) setCurrentStep(2)
        else if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER))
          setCurrentStep(1)
        else setCurrentStep(0)
        break
      case ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER:
        if (checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER)) setCurrentStep(5)
        else if (checkPermission(ASSIGNEE_TYPE.RELEASER)) setCurrentStep(6)
        else setCurrentStep(7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.READY_REJECTION:
        if (checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER)) setCurrentStep(5)
        else if (checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER)) setCurrentStep(4)
        else if (checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER))
          setCurrentStep(3)
        else if (checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)) setCurrentStep(2)
        else if (checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER))
          setCurrentStep(1)
        else setCurrentStep(0)
        break
      case ELECTRONIC_DOCUMENT_STATUS.READY:
        setCurrentStep(checkPermission(ASSIGNEE_TYPE.RELEASER) ? 6 : 7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.RELEASE_REJECTION:
        setCurrentStep(6)
        break
      case ELECTRONIC_DOCUMENT_STATUS.RELEASE:
        setCurrentStep(7)
        break
      case ELECTRONIC_DOCUMENT_STATUS.TP_CO_SIGN:
        setCurrentStep(1)
        break
      case ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER_REVERT: {
        const hasLeader = checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER)
        const hasForm = checkPermission(ASSIGNEE_TYPE.FORM_APPROVER)
        const hasDepartment = checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)

        if (!hasLeader) {
          if (!hasForm) {
            if (!hasDepartment) {
              setCurrentStep(0)
            } else {
              setCurrentStep(1)
            }
          } else {
            setCurrentStep(2)
          }
        } else {
          setCurrentStep(3)
        }
        break
      }

      default:
        break
    }
    const stepOrder = [
      ASSIGNEE_TYPE.CREATE,
      ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
      ASSIGNEE_TYPE.FORM_APPROVER,
      ASSIGNEE_TYPE.LEADER_APPROVER,
      ASSIGNEE_TYPE.NUMBER_ISSUER,
      ASSIGNEE_TYPE.DIGITAL_SIGNER,
      ASSIGNEE_TYPE.RELEASER,
    ]
    setStatusStep(
      stepOrder.map((_, i) =>
        i < currentStep ? 'finish' : i === currentStep ? 'process' : 'await'
      )
    )
  }, [status, checkPermission, currentStep])

  useEffect(() => {
    if (!action_history) return
    const fileInfo = action_history.find(el => el.action === status)
    setFileActive(fileInfo)
    const isPDFFile = utils.getExtensionFile(fileInfo?.file_name) === 'pdf'
    setFileActiveIsPDF(isPDFFile)

    const names = {
      creator_name: action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.PENDING
      )?.user.name_lowercase,
      tp_approval_name: action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.TP_APPROVAL
      )?.user.name_lowercase,
      vt_approval_name:
        action_history.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL
        )?.user?.name_lowercase ||
        action_history.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_SIGNED
        )?.user?.name_lowercase,
      lead_approval_name: action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL
      )?.user.name_lowercase,
      regis_number_name: action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
      )?.user.name_lowercase,
      sign_document_name: action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.READY
      )?.user.name_lowercase,
      release_name: action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.RELEASE
      )?.user.name_lowercase,
    }
    setHandlerName(names)

    const isSkipSign =
      action_history.find(el => el.action === ELECTRONIC_DOCUMENT_STATUS.READY)
        ?.file_id ===
      action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
      )?.file_id
    setSkipSignStates(prev => ({ ...prev, sign: isSkipSign }))
  }, [action_history])

  const showReleaseConfirm = useCallback(
    () =>
      confirm({
        title: 'Bạn có chắc chắn muốn phát hành tài liệu này?',
        icon: <InfoCircleTwoTone />,
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk: () => setPopupVisibility(prev => ({ ...prev, release: true })),
      }),
    [setPopupVisibility]
  )

  const showRevertRelease = useCallback(
    () =>
      confirm({
        title: 'Bạn có chắc chắn muốn phát hành lại tài liệu này?',
        icon: <InfoCircleTwoTone />,
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk: handleRevertRelease,
      }),
    [handleRevertRelease]
  )

  const showSignRevertConfirm = useCallback(
    () =>
      confirm({
        title: 'Bạn có chắc chắn muốn ký số lại tài liệu này?',
        icon: <InfoCircleTwoTone />,
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk: handleRevertSign,
      }),
    [handleRevertSign]
  )

  const showRevertNumberConfirm = useCallback(
    () =>
      confirm({
        title: 'Bạn có muốn cấp lại số tài liệu?',
        icon: <InfoCircleTwoTone />,
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk: handleRevertRegisNumber,
      }),
    [handleRevertRegisNumber]
  )

  // Render utilities
  const renderField = useCallback(
    (label, content) => (
      <>
        <dt style={{ lineHeight: '28px' }}>{label}</dt>
        <dd
          style={{
            display: 'flex',
            alignItems: 'center',
          }}>
          {content}
        </dd>
      </>
    ),
    []
  )

  const renderApproverContent = useCallback(
    approver =>
      approver ? (
        <AvatarHasName imgId={approver.image} name={approver.name_uppercase} />
      ) : (
        <span style={{ fontSize: '12px' }}>–</span>
      ),
    []
  )

  const renderPdf = useMemo(
    () => (
      <ViewerWrapper>
        {documentAttachment && (
          <PDFViewer
            file={documentAttachment}
            fileId={fileActive?.file_id}
            fileType={utils.getExtensionFile(fileActive?.file_name)}
          />
        )}
      </ViewerWrapper>
    ),
    [documentAttachment, fileActive]
  )

  const menuDuThao = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        <Menu.Item>
          <Upload
            accept={'.doc,.docx,application/pdf'}
            beforeUpload={() => false}
            showUploadList={false}
            onChange={onSelectDocument}>
            Chọn tài liệu khác
          </Upload>
        </Menu.Item>
      </Menu>
    ),
    [onSelectDocument]
  )

  const menuTPApproval = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        <Menu.Item onClick={handleDismissTPSign}>Bỏ qua ký số</Menu.Item>
        <Menu.Item onClick={showRevertTPConfirm}>Trình lại</Menu.Item>
      </Menu>
    ),
    [handleDismissTPSign, showRevertTPConfirm]
  )

  const menuVTApproval = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        <Menu.Item onClick={handleOpenModalPopupVTSign}>
          Ký số điện tử
        </Menu.Item>
      </Menu>
    ),
    [handleOpenModalPopupVTSign]
  )

  const menuLeadApproval = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        <Menu.Item onClick={handleDismissLeadSign}>Bỏ qua ký số</Menu.Item>
      </Menu>
    ),
    [handleDismissLeadSign]
  )

  const menuRegisNumber = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        <Menu.Item onClick={handleDismissRegisNumber}>Bỏ qua cấp số</Menu.Item>
        <Menu.Item onClick={showRevertToLeaderConfirm}>Duyệt lại</Menu.Item>
      </Menu>
    ),
    [handleDismissRegisNumber, showRevertToLeaderConfirm]
  )

  const menuSignDocument = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        <Menu.Item onClick={handleDismissSign}>Bỏ qua ký số</Menu.Item>
        {checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER) && (
          <Menu.Item onClick={showRevertNumberConfirm}>Cấp lại số</Menu.Item>
        )}
        {!checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER) && (
          <Menu.Item onClick={showRevertToLeaderConfirm}>Duyệt lại</Menu.Item>
        )}
      </Menu>
    ),
    [
      handleDismissSign,
      checkPermission,
      showRevertNumberConfirm,
      showRevertToLeaderConfirm,
    ]
  )

  const menuReleaseDocument = useMemo(
    () => (
      <Menu style={{ borderRadius: 8, padding: 4 }}>
        {checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER) && (
          <Menu.Item onClick={showSignRevertConfirm}>Ký số lại</Menu.Item>
        )}
        <Menu.Item onClick={handleOpenPopupRenameFile}>
          Đổi tên tài liệu
        </Menu.Item>
      </Menu>
    ),
    [checkPermission, showSignRevertConfirm, handleOpenPopupRenameFile]
  )

  // Hàm render file list
  const renderFiles = useCallback(
    (files, emptyText) => (
      <div>
        {files?.length > 0 ? (
          files.map(file => (
            <FileItem
              key={file.file_id}
              file_id={file.file_id}
              file_name={file.file_name}
              file_type={utils.getExtensionFile(file.file_name)}
            />
          ))
        ) : (
          <EmptyText>{emptyText}</EmptyText>
        )}
      </div>
    ),
    []
  )

  const stepsData = useMemo(() => {
    const stepConfigs = [
      {
        title: 'Tạo dự thảo',
        assignee: null,
        nameKey: 'creator_name',
        minStep: 0,
      },
      {
        title: 'Trưởng phòng duyệt',
        assignee: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
        nameKey: 'tp_approval_name',
        minStep: 1,
      },
      {
        title: 'Duyệt thể thức',
        assignee: ASSIGNEE_TYPE.FORM_APPROVER,
        nameKey: 'vt_approval_name',
        minStep: 1,
      },
      {
        title: 'Lãnh đạo duyệt',
        assignee: ASSIGNEE_TYPE.LEADER_APPROVER,
        nameKey: 'lead_approval_name',
        minStep: 0,
      },
      {
        title: 'Cấp số',
        assignee: ASSIGNEE_TYPE.NUMBER_ISSUER,
        nameKey: 'regis_number_name',
        minStep: 0,
      },
      {
        title: 'Ký số điện tử',
        assignee: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        nameKey: 'sign_document_name',
        minStep: 0,
      },
      {
        title: 'Phát hành',
        assignee: ASSIGNEE_TYPE.RELEASER,
        nameKey: 'release_name',
        minStep: 0,
      },
    ]

    return stepConfigs
      .map((step, index) => {
        const showStep = !step.assignee || checkPermission(step.assignee)
        if (!showStep) return null

        const name = handlerName[step.nameKey]
        const showDescription = step.minStep === 0 || currentStep > step.minStep

        return (
          <Step
            key={index}
            title={step.title}
            status={statusStep[index]}
            icon={
              <CustomStepIcon stepNumber={index + 1} currentStep={currentStep}>
                {currentStep >= index + 1 ? <CheckOutlined /> : index + 1}
              </CustomStepIcon>
            }
            description={
              name &&
              showDescription && (
                <div>
                  {step.minStep !== 0 && 'bởi '}
                  <span style={{ color: '#000', fontWeight: 600 }}>
                    {utils.getNameInCapitalize(name)}
                  </span>
                </div>
              )
            }
          />
        )
      })
      .filter(Boolean)
  }, [handlerName, currentStep, statusStep, checkPermission])

  const stepActions = useMemo(
    () => [
      {
        step: 0,
        acl: ACL_ACTION_TYPE.du_thao__PHAT_HANH_VB,
        label: 'Trình dự thảo',
        onClick: handlePresentDuThao,
        overlay: menuDuThao,
      },
      {
        step: 1,
        acl: ACL_ACTION_TYPE.truong_phong__PHAT_HANH_VB,
        label: 'Trưởng phòng ký số',
        onClick: handleOpenTPPopupSign,
        overlay: menuTPApproval,
        condition: () => {
          const isCoSigner =
            assigneesMap?.departmentCoSigners?.some(
              coSigner => coSigner.assignee_code === currentUser?.username
            ) || false
          return (
            checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER) && !isCoSigner
          )
        },
      },
      {
        step: 2,
        acl: ACL_ACTION_TYPE.van_thu_duyet__PHAT_HANH_VB,
        render: () => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            <AccessControlAction
              aclActionType={ACL_ACTION_TYPE.van_thu_duyet__PHAT_HANH_VB}>
              {checkAccessControlAction(
                ACL_ACTION_TYPE.van_thu_ky_so__PHAT_HANH_VB
              ) ? (
                <Dropdown.Button
                  size="large"
                  trigger={['click']}
                  onClick={handleVTApproval}
                  overlay={menuVTApproval}
                  type="primary">
                  <CheckOutlined style={{ marginRight: 4 }} /> Văn thư duyệt
                </Dropdown.Button>
              ) : (
                <Button
                  onClick={handleVTApproval}
                  type="primary"
                  style={{ width: 380 }}>
                  Văn thư duyệt
                </Button>
              )}
            </AccessControlAction>
            <AccessControlAction
              aclActionType={ACL_ACTION_TYPE.van_thu_huy_duyet__PHAT_HANH_VB}>
              <Button
                onClick={handleRevertVTApproval}
                icon={<CloseOutlined />}
                type="primary"
                style={{ width: 380, marginTop: 8 }}
                danger>
                Văn thư hủy duyệt
              </Button>
            </AccessControlAction>
          </div>
        ),
      },
      {
        step: 3,
        render: () => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            <AccessControlAction
              aclActionType={ACL_ACTION_TYPE.lanh_dao_duyet__PHAT_HANH_VB}>
              <Dropdown.Button
                style={{ width: 380 }}
                size="large"
                block
                type="primary"
                onClick={handleOpenModalPopupSign}
                overlay={menuLeadApproval}>
                Lãnh đạo ký số
              </Dropdown.Button>
            </AccessControlAction>
            <AccessControlAction
              aclActionType={ACL_ACTION_TYPE.lanh_dao_huy_duyet__PHAT_HANH_VB}>
              <Button
                onClick={handleRevertLeaderApproval}
                icon={<CloseOutlined />}
                type="primary"
                style={{ width: 380, marginTop: 8 }}
                danger>
                Lãnh đạo hủy duyệt
              </Button>
            </AccessControlAction>
          </div>
        ),
      },
      {
        step: 4,
        acl: ACL_ACTION_TYPE.cap_so__PHAT_HANH_VB,
        label: 'Cấp số tài liệu',
        onClick: () => {
          if (
            checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER) &&
            !assigneesMap.digitalSigner &&
            currentStep === 4
          ) {
            return message.warning('Bạn chưa chọn người ký số điện tử!')
          }
          if (!fileActiveIsPDF) {
            return message.info('Bạn chỉ được phép cấp số file PDF')
          }
          setPopupVisibility(prev => ({ ...prev, regisNumber: true }))
        },
        overlay: menuRegisNumber,
      },
      {
        step: 5,
        acl: ACL_ACTION_TYPE.ky_so_tai_lieu__PHAT_HANH_VB,
        label: 'Ký số tài liệu',
        onClick: handleOpenPopupSign,
        overlay: menuSignDocument,
      },
      {
        step: 6,
        acl: ACL_ACTION_TYPE.phat_hanh_tai_lieu__PHAT_HANH_VB,
        label: 'Phát hành tài liệu',
        onClick: showReleaseConfirm,
        overlay: menuReleaseDocument,
      },
      {
        step: 7,
        acl: ACL_ACTION_TYPE.re_release__PHAT_HANH_VB,
        render: () => (
          <Button
            size="large"
            style={{ width: 380 }}
            onClick={showRevertRelease}
            type="primary">
            <CheckOutlined /> Phát hành lại
          </Button>
        ),
      },
    ],
    [
      assigneesMap,
      fileActiveIsPDF,
      setPopupVisibility,
      handleOpenPopupSign,
      handlePresentDuThao,
      handleVTApproval,
      handleRevertVTApproval,
      handleOpenTPPopupSign,
      handleOpenModalPopupSign,
      handleRevertLeaderApproval,
      showReleaseConfirm,
      showRevertRelease,
      menuTPApproval,
      menuVTApproval,
      menuRegisNumber,
      menuSignDocument,
      menuReleaseDocument,
      menuDuThao,
    ]
  )

  // Handle adding a new co-signer
  const handleSubmitCoSigners = useCallback(async () => {
    const { code } = selectedElectronicDocument
    const newCoSigners =
      selectPeopleStore.selectUserData[ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER] || []
    const existingCoSigners = assigneesMap.departmentCoSigners || []

    const new_items_assign = newCoSigners.map(user => ({
      assignee_code: user.id,
      assignee_type: user.assignee_type || ASSIGNEE_TYPE.USER,
      permission: ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER,
    }))

    const remove_items_assign = existingCoSigners
      .filter(
        existing =>
          !newCoSigners.some(newUser => newUser.id === existing.assignee_code)
      )
      .map(existing => ({
        assignee_code: existing.assignee_code,
        assignee_type: existing.assignee_type,
        permission: ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER,
      }))

    if (newCoSigners.length === 0 && remove_items_assign.length === 0) {
      message.info('Vui lòng chọn ít nhất một trưởng phòng ký!')
      return
    }

    try {
      loadingAnimationStore.showSpinner(true)
      const dataSubmit = {
        new_items: new_items_assign,
        remove_items: remove_items_assign,
      }
      await electronicDocumentStore.updateAssignPerson(code, dataSubmit)
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      // Update assigneesMap with the latest data
      // electronicDocumentStore.setSelectedElectronicDocument({
      //   ...selectedElectronicDocument,
      //   assignees: data.assignees,
      // })
      selectPeopleStore.setIsVisibleSelectUserDepartmentPopup(false)
      message.success('Cập nhật trưởng phòng ký thành công!')
      setCurrentCoSignerIndex(0) // Reset to the first co-signer after adding new ones
    } catch (err) {
      console.error('Error in handleSubmitCoSigners:', err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    selectedElectronicDocument,
    selectPeopleStore,
    electronicDocumentStore,
    loadingAnimationStore,
    assigneesMap,
    setCurrentCoSignerIndex,
  ])

  const handleOpenSignPopup = useCallback(() => {
    if (coSigners.length === 0) {
      message.warning('Không có trưởng phòng ký nào được chọn!')
      return
    }
    if (currentCoSignerIndex >= coSigners.length) {
      message.success('Tất cả trưởng phòng ký đã hoàn thành ký số!')
      return
    }
    setIsVisiblePopupSign(true)
  }, [coSigners, currentCoSignerIndex])

  // Handle after a co-signer signs
  const handleAfterCoSign = useCallback(
    async fileSignId => {
      try {
        loadingAnimationStore.showSpinner(true)
        await electronicDocumentStore.getElectronicDocumentById(
          selectedElectronicDocument.code
        )
        // Move to the next co-signer
        setCurrentCoSignerIndex(prev => prev + 1)
        message.success(
          `Trưởng phòng ${coSigners[currentCoSignerIndex].full_name} đã ký thành công!`
        )
        // Close PopupSign if this was the last co-signer
        if (currentCoSignerIndex + 1 >= coSigners.length) {
          setIsVisiblePopupSign(false)
          message.success('Hoàn thành ký số cho tất cả trưởng phòng!')
        }
      } catch (err) {
        console.error('Error after signing:', err)
        message.error(err?.vi || 'Đã có lỗi xảy ra khi cập nhật tài liệu!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [
      currentCoSignerIndex,
      coSigners,
      selectedElectronicDocument,
      electronicDocumentStore,
      loadingAnimationStore,
    ]
  )

  // Handle closing the PopupSign
  const handleClosePopupSign = useCallback(() => {
    setIsVisiblePopupSign(false)
    signedDocumentStore.clearDataPopupSign()
  }, [signedDocumentStore])

  // Reset co-signer index when document changes
  useEffect(() => {
    setCurrentCoSignerIndex(0)
    // setCurrentFileId(selectedElectronicDocument?.file_id)
  }, [selectedElectronicDocument?.code])

  return (
    <>
      <CanvasDocHeader>
        <Steps
          labelPlacement={'vertical'}
          size={'small'}
          current={currentStep}
          direction="horizontal"
          style={{ marginBottom: 12 }}>
          {stepsData}
        </Steps>
        <ButtonItem>
          {stepActions.map(item => {
            if (item.step !== currentStep) return null
            if (item.render) return item.render()
            if (
              item.step === 1 &&
              checkPermission(ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER) &&
              !checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER)
            ) {
              return null
            }
            if (item.condition && !item.condition()) {
              return null
            }
            return (
              <AccessControlAction key={item.step} aclActionType={item.acl}>
                <Dropdown.Button
                  size="large"
                  trigger={['click']}
                  onClick={item.onClick}
                  overlay={item.overlay}
                  type="primary">
                  <CheckOutlined style={{ marginRight: 4 }} /> {item.label}
                </Dropdown.Button>
              </AccessControlAction>
            )
          })}
        </ButtonItem>
      </CanvasDocHeader>
      <CanvasDocWrapper>
        {renderPdf}
        <BlockRight>
          <div style={{ backgroundColor: '#f5f7fa', padding: '16px 24px 24px 24px', borderRadius: 16 }}>
            <Tabs defaultActiveKey="1" className="custom-detail-tabs">
              <Tabs.TabPane tab="Thông tin chung" key="1">
                <ElectronicDocumentInfo>
                  {renderField(
                    'Tạo dự thảo',
                    <AvatarHasName
                      imgId={assigneesMap.creator?.image}
                      name={assigneesMap.creator?.name_uppercase}
                    />
                  )}
                  {checkPermission(ASSIGNEE_TYPE.DEPARTMENT_APPROVER) &&
                    renderField(
                      'Trưởng phòng duyệt',
                      renderApproverContent(assigneesMap.departmentApprover)
                    )}
                  {checkPermission(ASSIGNEE_TYPE.FORM_APPROVER) &&
                    renderField(
                      'Duyệt thể thức',
                      renderApproverContent(assigneesMap.formApprover)
                    )}
                  {checkPermission(ASSIGNEE_TYPE.LEADER_APPROVER) &&
                    renderField(
                      'Lãnh đạo duyệt',
                      renderApproverContent(assigneesMap.leaderApprover)
                    )}
                  {checkPermission(ASSIGNEE_TYPE.NUMBER_ISSUER) &&
                    renderField(
                      'Cấp số',
                      renderApproverContent(assigneesMap.numberIssuer)
                    )}
                  {checkPermission(ASSIGNEE_TYPE.DIGITAL_SIGNER) &&
                    renderField(
                      'Ký số điện tử',
                      renderApproverContent(assigneesMap.digitalSigner)
                    )}
                  {checkPermission(ASSIGNEE_TYPE.RELEASER) &&
                    renderField(
                      'Phát hành',
                      renderApproverContent(assigneesMap.releaser)
                    )}
                  {renderField(
                    'Ngày trình ký',
                    <>
                      <CalendarOutlined style={{ color: blue, marginRight: 6 }} />
                      {dayjs(created_date).format(DATE_FORMAT_DEFAULT)}
                    </>
                  )}
                  {renderField(
                    'Tài liệu trình ký',
                    <FileItem
                      file_id={fileActive?.file_id}
                      file_name={fileActive?.file_name}
                      file_type={utils.getExtensionFile(fileActive?.file_name)}
                    />
                  )}
                  {renderField(
                    'Phụ lục đi kèm',
                    renderFiles(annex_attachments, 'Không có phụ lục đi kèm')
                  )}
                  {renderField(
                    'Tài liệu đính kèm',
                    renderFiles(attachments, 'Không có tài liệu đính kèm')
                  )}
                  {renderField(
                    'Liên kết công việc',
                    <LinkedWork linkedWorkList={linkedWorkList} />
                  )}
                </ElectronicDocumentInfo>
              </Tabs.TabPane>
              
              <Tabs.TabPane tab="Ý kiến" key="2">
                <div style={{ position: 'relative' }}>
                  <CommentBlock signDocumentId={code} />
                  <SpinnerInlineComponent sizeSpin={'small'} />
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Lịch sử hoạt động" key="3">
                <InternalDocumentSignDocHistory
                  historyAction={electronicDocumentStore.electronicHistory}
                  status={electronicDocumentStore.electronicCurentAction}
                  historyId={code}
                  historyLists={historyLists}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
          <style>{`
            .custom-detail-tabs .ant-tabs-nav::before {
              border-bottom: 1px solid #f0f0f0;
            }
            .custom-detail-tabs .ant-tabs-tab {
              padding: 12px 0;
              font-weight: 500;
            }
          `}</style>
        </BlockRight>
      </CanvasDocWrapper>
      <PopupRenameFile
        isModalVisibleRenameFile={renameFileState.visible}
        handleCloseModalRenameFile={() =>
          setRenameFileState(prev => ({ ...prev, visible: false }))
        }
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={renameFileState.fields}
        fileExt={renameFileState.ext}
      />
      {popupVisibility.release && (
        <PopupReleaseElectronicDocument
          fileActive={fileActive}
          selectedElectronicDocument={selectedElectronicDocument}
          handleClosePopupElectronicDocument={() =>
            setPopupVisibility(prev => ({ ...prev, release: false }))
          }
          isVisiblePopupRelease={popupVisibility.release}
        />
      )}
      {popupVisibility.regisNumber && (
        <PopupRegisNumber
          handleClosePopupRegisNumber={() =>
            setPopupVisibility(prev => ({ ...prev, regisNumber: false }))
          }
          isVisiblePopupRegisNumber={popupVisibility.regisNumber}
          fileActive={fileActive}
        />
      )}
      {popupVisibility.sign && (
        <PopupSign
          isVisiblePopupSign={popupVisibility.sign}
          handleClosePopupSign={() =>
            setPopupVisibility(prev => ({ ...prev, sign: false }))
          }
          hiddenSelectDocument
          hiddenFooterOption
          fileId={fileActive?.file_id}
          handleAfterSign={handleAfterSign}
        />
      )}
      {popupVisibility.modalSign && (
        <ModalPopupSign
          isVisiblePopupSign={popupVisibility.modalSign}
          handleClosePopupSign={() =>
            setPopupVisibility(prev => ({ ...prev, modalSign: false }))
          }
          hiddenSelectDocument
          fileId={fileActive?.file_id}
          handleAfterSign={handleAfterLeaderSign}
        />
      )}
      {popupVisibility.vtSign && (
        <VTPopupSign
          isVisiblePopupSign={popupVisibility.vtSign}
          handleClosePopupSign={() =>
            setPopupVisibility(prev => ({ ...prev, vtSign: false }))
          }
          hiddenSelectDocument
          fileId={fileActive?.file_id}
          handleAfterSign={handleAfterVTSign}
        />
      )}
      {popupVisibility.tpSign && (
        <TPPopupSign
          isVisiblePopupSign={popupVisibility.tpSign}
          handleClosePopupSign={() =>
            setPopupVisibility(prev => ({ ...prev, tpSign: false }))
          }
          hiddenSelectDocument
          fileId={fileActive?.file_id}
          handleAfterSign={handleAfterTPSign}
        />
      )}
      {popupVisibility.tpCoSign && (
        <PopupTPApproverSign
          isVisiblePopupSign={popupVisibility.tpCoSign}
          handleClosePopupSign={() =>
            setPopupVisibility(prev => ({ ...prev, tpCoSign: false }))
          }
          hiddenSelectDocument
          fileId={fileActive?.file_id}
          handleAfterSign={handleAfterTPCoSign}
          currentCoSigner={coSigners[currentCoSignerIndex]}
          coSigners={coSigners}
        />
      )}
      <SelectPeoplePopup
        onlyOneUser={false}
        disableSelectDepartment
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={handleSubmitCoSigners}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
    </>
  )
}

export default inject(
  'signedDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'fileStore',
  'electronicDocumentStore',
  'listHistoryLogStore',
  'selectPeopleStore',
  'aclStore'
)(observer(CanvasDoc))
